<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" compact="true"></app-side-menu>

<app-nav-bar [sideBar]="false" (navMessage$)="listenerNav($event)"></app-nav-bar>

<app-footer [sideBar]="false"></app-footer>

<div class="content-page">

    <div class="content">

        <div class="container-fluid">

            <ul class="nav nav-tabs">
                <li class="nav-item" (click)="tabSelected($event, 'dashboard-tab')">
                    <a class="nav-link" id="dashboard-tab-link" data-toggle="tab" data-target="#dashboard-tab" role="tab">
                        <span class="material-icons">dashboard</span>
                    </a>
                </li>
                <li class="nav-item" (click)="tabSelected($event, 'past-due-tab')">
                    <a class="nav-link" id="past-due-tab-link" data-toggle="tab" data-target="#past-due-tab" role="tab">
                        <span class="material-icons">access_time</span> Past Due Accounts
                    </a>
                </li>
                <li class="nav-item" (click)="tabSelected($event, 'manage-collectors-tab')">
                    <a class="nav-link" id="manage-collectors-tab-link" data-toggle="tab" data-target="#manage-collectors-tab" role="tab">
                        <span class="material-icons">person</span> Manage Collectors
                    </a>
                </li>
            </ul>

            <div class="tab-content">

                <div class="tab-pane fade" id="dashboard-tab" role="tabpanel">
                    <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4" id="stat-bar">

                        <div class="col">
                            <div class="card stat bg-danger text-white" id="stat-past-due">
                                <div class="row no-gutters">
                                    <div class="d-none d-lg-flex col-lg-3 stat-count">
                                        <h1>33</h1>
                                    </div>
                                    <div class="col-xs-12 col-lg-9">
                                        <div class="card-body">
                                            <h2 class="card-title text-truncate">$9,321</h2>
                                            <p class="card-text">Past due payments</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="card stat bg-secondary text-white" id="stat-due-month">
                                <div class="row no-gutters">
                                    <div class="d-none d-lg-flex col-lg-3 stat-count">
                                        <h1>197</h1>
                                    </div>
                                    <div class="col-xs-12 col-lg-9">
                                        <div class="card-body">
                                            <h2 class="card-title text-truncate">$139,641</h2>
                                            <p class="card-text">Left to collect this month</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="card stat bg-success text-white" id="stat-collected-month">
                                <div class="row no-gutters">
                                    <div class="d-none d-lg-flex col-lg-3 stat-count">
                                        <h1>21</h1>
                                    </div>
                                    <div class="col-xs-12 col-lg-9">
                                        <div class="card-body">
                                            <h2 class="card-title text-truncate">$7,453</h2>
                                            <p class="card-text">Collected this month</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="card stat bg-warning text-white" id="stat-promised">
                                <div class="row no-gutters">
                                    <div class="d-none d-lg-flex col-lg-3 stat-count">
                                        <h1>9</h1>
                                    </div>
                                    <div class="col-xs-12 col-lg-9">
                                        <div class="card-body">
                                            <h2 class="card-title text-truncate">$1,339.87</h2>
                                            <p class="card-text">Promised to pay this week</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div id="search-bar">
                        <datalist id="matched-contacts">
                            @for (contact of contacts; track contact) {
                                <option [value]="displayContact(contact)"></option>
                            }
                        </datalist>

                        <datalist id="matched-sales">
                            @for (sale of sales; track sale) {
                                <option [value]="displaySale(sale)"></option>
                            }
                        </datalist>

                        <form [formGroup]="form" class="form-row">
                            <div class="form-group col-xs-12 col-lg-6">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                                    </div>

                                    <input autocomplete="off" type="search" class="form-control" id="sale-search" autofocus="false" list="matched-sales" formControlName="sale" placeholder="Find a sale" />

                                    <div class="input-group-append">
                                        <select class="form-control" name="financeType" id="finance-type-filter" formControlName="financeType">
                                            <option value="0">All {{words[language]['sales']}}</option>
                                            @if (enableBHPH) {
                                                <option value="4">Buy Here - Pay Here</option>
                                            }
                                            <option value="3">Outside Finance</option>
                                            <option value="1">Cash</option>
                                            <option value="2">Wholesale</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-xs-12 col-lg-6">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                                    </div>

                                    <input autocomplete="off" type="search" class="form-control" id="contact-search" autofocus="false" list="matched-contacts" formControlName="contact" placeholder="Find a contact" />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="card-columns">

                        <downs-deposits [lotId]="lotId" [financeTypeId]="financeTypeId" [contactId]="contactId" [language]="language"></downs-deposits>

                        <pays-due-soon [lotId]="lotId" [financeTypeId]="financeTypeId" [contactId]="contactId" [language]="language"></pays-due-soon>

                        <pay-promises [lotId]="lotId" [financeTypeId]="financeTypeId" [contactId]="contactId" [language]="language"></pay-promises>

                        <receipts [lotId]="lotId" [financeTypeId]="financeTypeId" [contactId]="contactId" [language]="language"></receipts>

                    </div>

                </div>

                <div class="tab-pane fade" id="past-due-tab" role="tabpanel">

                    <aside>
                        <pays-past-due [lotId]="lotId" [financeTypeId]="4" [language]="language" (accountChosen)="pastDueChosen($event)"></pays-past-due>
                    </aside>

                    <main>
                        <past-due-view [termsId]="termsId" [saleId]="pastDueSaleId" [contactId]="pastDueAccountId"></past-due-view>
                    </main>

                </div>

                <div class="tab-pane fade" id="manage-collectors-tab" role="tabpanel">

                    <collectors [words]="words" [language]="language"/>

                </div>
            </div>

        </div>

    </div>

</div>